import React from "react";
import { Spinner } from "react-bootstrap";

export const RazorpayPaymentButton = ({
  subscribeToPlanRazorPay,
  estimatedData,
  loading = false,
  disabled = false,
}) => {
  return (
    <div className="text-center">
      <img
        src="https://cdn.worldvectorlogo.com/logos/razorpay.svg"
        alt="rzp"
        className="img-fluid "
        style={{ width: "35%" }}
      />
      <button
        className="razorpay-btn d-flex align-items-center justify-content-center gap-2 px-4 py-2 rounded"
        type="button"
        disabled={disabled || loading}
        onClick={disabled || loading ? undefined : subscribeToPlanRazorPay}
      >
        {loading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="me-2"
            />
            <span style={{ color: "#ffffff", fontWeight: 500 }}>
              Processing...
            </span>
          </>
        ) : (
          <span style={{ color: "#ffffff", fontWeight: 500 }}>
            {estimatedData?.trial_eligibility
              ? "Start Free Trial"
              : "Proceed to pay"}
          </span>
        )}
      </button>
    </div>
  );
};
